import { useQuery } from '@tanstack/react-query'
import * as endpoints from '@/endpoints'
import axios from '@/lib/axios'

export const useNotificationsQuery = () =>
    useQuery({
        queryKey: ['notifications'],
        queryFn: () => axios.get(endpoints.NOTIFICATIONS).then((r) => r.data),
        staleTime: 1000 * 30
    })
